import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/siteData";
import serviceCx from "@/assets/icons/service-cx-new.webp";
import serviceHealthcare from "@/assets/icons/service-healthcare-new.webp";
import serviceVa from "@/assets/icons/service-va-new.webp";
import serviceSales from "@/assets/icons/service-sales-new.webp";
import serviceDebt from "@/assets/icons/service-debt-new.webp";
import serviceData from "@/assets/icons/service-data-new.webp";
import serviceTech from "@/assets/icons/service-tech-new.webp";
import serviceRecruitment from "@/assets/icons/service-recruitment-new.webp";
import arrowIcon from "@/assets/icons/arrow-icon.png";

const iconMap: Record<string, string> = {
  "service-cx": serviceCx,
  "service-healthcare": serviceHealthcare,
  "service-va": serviceVa,
  "service-sales": serviceSales,
  "service-debt": serviceDebt,
  "service-data": serviceData,
  "service-tech": serviceTech,
  "service-recruitment": serviceRecruitment,
};

export function ServicesGrid() {
  const firstRow = services.slice(0, 4);

  const ServiceCard = ({ service, index }: { service: typeof services[0]; index: number }) => {
    const iconSrc = iconMap[service.icon];
    const baseDelay = index * 80;
    
    return (
      <Link
        to={service.href}
        className="bg-[#E8E8E8] rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 animate-fade-up relative group flex flex-col"
        style={{ animationDelay: `${baseDelay}ms` }}
      >
        <div className="flex items-start justify-between mb-6">
          {iconSrc && (
            <img src={iconSrc} alt="" className="w-14 h-14 rounded-full object-contain" />
          )}
          <div className="w-8 h-8 rounded-full bg-[#E84B8A] flex items-center justify-center">
            <img src={arrowIcon} alt="" className="h-4 w-4" />
          </div>
        </div>
        
        <h3 className="text-sm font-bold text-foreground mb-4 uppercase tracking-wide whitespace-nowrap">
          {service.title}
        </h3>

        <div className="mt-auto pt-2">
          <span className="inline-flex items-center gap-1.5 text-primary font-semibold text-xs uppercase tracking-wide group/link hover:gap-2.5 transition-all">
            Learn More
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </span>
        </div>
      </Link>
    );
  };

  return (
    <section className="py-10 md:py-14 bg-background">
      <div className="container-main">
        <div className="text-center mb-8">
          <span className="section-label">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-foreground mt-4 uppercase leading-tight">
            Dedicated Talent, Built Around Your Business
          </h2>
          <p className="text-muted-foreground mt-6 max-w-4xl mx-auto text-base leading-relaxed">
            We place friendly, empathetic and patient people who become the voice, the face and the ears between your company and the public. Trained, experienced and dedicated solely to you — with <strong className="whitespace-nowrap">no minimum headcount</strong>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {firstRow.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.slice(4, 8).map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index + 4} />
          ))}
        </div>
      </div>
    </section>
  );
}
